// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"5a098fe6","170":"22f29d0b","592":"dcd6260f","872":"afa30b32"}[chunkId] + ".chunk.js";
};